import { PageRef } from 'providers/page-ref';

export type AdminExerciseSlotListPageParams = {};

export const IAdminExerciseSlotListPage: PageRef<AdminExerciseSlotListPageParams, void> = {
  pageName: 'AdminExerciseSlotListPage',
} as PageRef<AdminExerciseSlotListPageParams, void>;
